import AWSLogo from "../components/Logos/AWSLogo";
import BootStrapLogo from "../components/Logos/BootStrapLogo";
import CplusPlusLogo from "../components/Logos/CplusPlusLogo";
import CssLogo from "../components/Logos/CssLogo";
import DockerLogo from "../components/Logos/DockerLogo";
import ExpressJSLogo from "../components/Logos/ExpressJSLogo";
import FlaskLogo from "../components/Logos/FlaskLogo";
import GithubLogo from "../components/Logos/GithubLogo";
import GitLogo from "../components/Logos/GitLogo";
import GraphQLLogo from "../components/Logos/GraphQLLogo";
import HTMLLogo from "../components/Logos/HTMLLogo";
import JavaScriptLogo from "../components/Logos/JavaScriptLogo";
import MongoDBLogo from "../components/Logos/MongoDBLogo";
import MUILogo from "../components/Logos/MUILogo";
import MySQLLogo from "../components/Logos/MySQLLogo";
import NextJSLogo from "../components/Logos/NextJSLogo";
import NodeJSLogo from "../components/Logos/NodeJSLogo";
import PostgreSQLLogo from "../components/Logos/PostgreSQLLogo";
import PostmanLogo from "../components/Logos/PostmanLogo";
import PrismaLogo from "../components/Logos/PrismaLogo";
import PugJSLogo from "../components/Logos/PugJSLogo";
import PyCharmLogo from "../components/Logos/PyCharmLogo";
import PythonLogo from "../components/Logos/PythonLogo";
import ReactLogo from "../components/Logos/ReactLogo";
import ReactQueryLogo from "../components/Logos/ReactQueryLogo";
import RedisLogo from "../components/Logos/RedisLogo";
import ReduxLogo from "../components/Logos/ReduxLogo";
import SassLogo from "../components/Logos/SassLogo";
import SQLiteLogo from "../components/Logos/SQLiteLogo";
import TailWindCSSLogo from "../components/Logos/TailWindCSSLogo";
import TypeScriptLogo from "../components/Logos/TypeScriptLogo";
import VisualStudioCodeLogo from "../components/Logos/VisualStudioCodeLogo";

export const TechSkills = {
  // programmingLanguages
  JavaScript: { logo: JavaScriptLogo, title: "JavaScript" },
  Python: { logo: PythonLogo, title: "Python" },
  TypeScript: { logo: TypeScriptLogo, title: "TypeScript" },
  CPlusPlus: { logo: CplusPlusLogo, title: "C++" },

  // backendTechnologies
  NodeJS: { logo: NodeJSLogo, title: "Node.js" },
  ExpressJS: { logo: ExpressJSLogo, title: "Express.js" },
  MongoDB: { logo: MongoDBLogo, title: "MongoDB" },
  PostgreSQL: { logo: PostgreSQLLogo, title: "PostgreSQL" },
  MySQL: { logo: MySQLLogo, title: "MySQL" },
  GraphQL: { logo: GraphQLLogo, title: "GraphQL" },
  Redis: { logo: RedisLogo, title: "Redis" },
  Flask: { logo: FlaskLogo, title: "Flask" },
  Prisma: { logo: PrismaLogo, title: "PrismaORM" },
  SQLite: { logo: SQLiteLogo, title: "SQLite" },
  // frontendTechnologies
  React: { logo: ReactLogo, title: "React" },
  NextJS: { logo: NextJSLogo, title: "Next.js" },
  ReactQuery: { logo: ReactQueryLogo, title: "React Query" },
  Redux: { logo: ReduxLogo, title: "Redux" },
  PugJS: { logo: PugJSLogo, title: "Pug.js" },
  HTML: { logo: HTMLLogo, title: "HTML" },
  MUI: { logo: MUILogo, title: "Material UI" },

  // stylingTechnologies
  CSS: { logo: CssLogo, title: "CSS" },
  TailwindCSS: { logo: TailWindCSSLogo, title: "Tailwind CSS" },
  Sass: { logo: SassLogo, title: "Sass" },
  Bootstrap: { logo: BootStrapLogo, title: "Bootstrap" },

  // tools
  Git: { logo: GitLogo, title: "Git" },
  GitHub: { logo: GithubLogo, title: "GitHub" },
  Docker: { logo: DockerLogo, title: "Docker" },
  Postman: { logo: PostmanLogo, title: "Postman" },
  VSCode: { logo: VisualStudioCodeLogo, title: "VS Code" },
  PyCharm: { logo: PyCharmLogo, title: "PyCharm" },
  AWS: { logo: AWSLogo, title: "AWS" },
};
